/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Recorder_Pre_Roll_LabelInputs */



/**
* | output |
* | --- |
* | "Pre-roll" |
*
* @param {Audio_Recorder_Pre_Roll_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_pre_roll_label = /** @type {((inputs?: Audio_Recorder_Pre_Roll_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Pre_Roll_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pré-roll")
	if (locale === "de") return /** @type {LocalizedString} */ ("Pre-Roll")
	if (locale === "it") return /** @type {LocalizedString} */ ("Pre-roll")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Предварительно скрученный джойнт")
	if (locale === "es") return /** @type {LocalizedString} */ ("Pre-roll")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("预卷")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プレロール")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्री-रोल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Pré-enrolado")
	return /** @type {LocalizedString} */ ("Pre-roll")
});